import { createEntityAdapter, createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export const NAMESPACE = 'toast';

export type ToastContentLevel = 'success' | 'error';

export interface ToastContent {
  id: string;
  level: ToastContentLevel;
  content: string;
  createdAtTimestamp: number;
}

export const buildToastContent = (level: ToastContentLevel, content: string): ToastContent => ({
  id: nanoid(8),
  level,
  content,
  createdAtTimestamp: Date.now(),
});

export const toastAdapter = createEntityAdapter<ToastContent>({
  sortComparer: (a, b) => b.createdAtTimestamp - a.createdAtTimestamp,
});

export const initialState = toastAdapter.getInitialState();
const toastSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    addOne: (state, action: PayloadAction<ToastContent>) => {
      toastAdapter.addOne(state, action.payload);
    },
    removeOne: (state, action: PayloadAction<string>) => {
      toastAdapter.removeOne(state, action.payload);
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { addOne, removeOne, reset } = toastSlice.actions;

export default toastSlice;
